import { render, staticRenderFns } from "./Reply.vue?vue&type=template&id=0994cd82&scoped=true&lang=html"
import script from "./Reply.vue?vue&type=script&lang=js"
export * from "./Reply.vue?vue&type=script&lang=js"
import style0 from "./Reply.vue?vue&type=style&index=0&id=0994cd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0994cd82",
  null
  
)

export default component.exports